<ul class="nav navbar-nav navbar-right btn-group">
	{{> (lookup. 'menubar' isMobile=isMobile) }}
</ul>
{{#if hasMessage}}
<div class="menu-message">
	<button id="js-show-message" class="message">{{TR "HINWEIS"}}</button>
</div>
{{/if}}
